<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
  <div class="row mb-2">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pt-2">
          <div class="text-center text-danger">
            <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
              details</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
  <div class="row">
    <div class="col-12">
      <h4 class="mb-2 font-header-1">Clearing House</h4>
    </div>
  </div>
  <div class="row mt-2 ">
    <div class="col pl-0">
      <div widget class="card border-0 box-shadow">
        <div class="card-body  widget-body pb-0 pt-2 mb-4">

          <div class="row no-gutters ">

            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-5 d-none d-lg-block  mt-1">
              <button type="button" class="btn blue-btn btn-sm" data-bs-toggle="modal" data-bs-target="#modal"
                (click)="OpenCreateupdate('new')" *ngIf="fp.clearinghousecreate">Add
                Clearing House</button>&nbsp;&nbsp;
            </div>


            <div class="col text-right text-end ">
              <button type="button" class="btn btn-sm" (click)="Refresh()">
                <i class="fa fa-repeat"> </i>Refresh
              </button>&nbsp;&nbsp;
            </div>
          </div>

          <div class="row mt-3" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
          global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
            <div class="col mb-0">
              <ejs-grid #grid [dataSource]='data | async' [allowResizing]='true' [allowSorting]='true'
                allowPaging='true' [allowFiltering]='true' (resizeStop)="onResize($event)" [pageSettings]='initialPage'
                [filterSettings]='filterOptions' (actionBegin)="onActionComplete($event)" [showColumnChooser]='true'
                (dataStateChange)='dataStateChange($event)'>
                <e-columns>
                  <e-column minWidth=100 uid="action" headerText="Actions" textAlign="center"
                    [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                      <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#modal"
                        (click)="OpenCreateupdate('edit');selectCHDetails(data)" *ngIf="fp.clearinghouseupdate">
                        <i class="fa fa-edit"></i></button>&nbsp;
                    </ng-template>

                    <!-- <ng-template #template let-data >
                      <input type="radio" (change)="caseemit(data)" >
                     </ng-template> -->
                  </e-column>
                  <e-column minWidth=100 field="name" headerText="Name" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="tradingPartnerId" headerText="Trading Partner ID" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="receiverIDQualifier_Name" headerText="Receiver ID Qualifier"
                    type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column field="receiverId" minWidth=100 headerText="Receiver Id" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>
                  <e-column minWidth=100 field="senderIdQualifier_Name" headerText="Sender Id Qualifier" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>

                  <e-column minWidth=100 field="senderId" headerText="Sender Id" type="string">
                    <ng-template #filterTemplate let-data>
                      <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                  </e-column>



                  <!--------------------------------table header icon---------------->
                  <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                      <div>
                        <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                      </div>
                    </ng-template>
                  </e-column>
                </e-columns>
              </ejs-grid>
              <!-- <div *ngIf="ClearingDataList.length == 0 &&  global.globalAgencyId!=0" class="text-center" style="color:red">
                    <p>No data available</p>
                  </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


<span id="openModal1" data-bs-target="#modal" data-bs-toggle="modal"></span>
<div class="modal fade modalbackgrod" id="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-bs-backdrop="static">

  <div class="modal-dialog CHAddUPdateModel" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel"><span *ngIf="ModelType =='new'"> Create Clearing
            House</span> <span *ngIf="ModelType =='edit'">Update Clearing
            House</span> </h5>
        
      </div>
      <div class="modal-body" style="overflow-y:auto;height: 280px;">
        <form [formGroup]="clearHouseForm">


          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Name <sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="Name" [(ngModel)]="ClearH.name">
            </div>
          </div>
          <span class="help-block text-danger text-center"
            *ngIf="!clearHouseForm.get('Name').valid && clearHouseForm.get('Name').touched">
            <p>Please Enter Name</p>
          </span>

          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Trading Partner ID<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <input type="text" min="0" class="form-control" formControlName="TradingPartner"
                [(ngModel)]="ClearH.tradingPartnerId">
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Sender ID<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="SenderID" [(ngModel)]="ClearH.senderId">
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Sender ID Qualifier<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <select class="form-control" formControlName="SenderIDQualifier" [(ngModel)]="ClearH.senderIDQualifierLid"
                (ngModelChange)="checkpopup('SenderIDQualifierLid')">
                <option [value]=i.Key *ngFor="let i of  senderidQualifier">{{i.Value}}</option>
              </select>
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Receiver ID<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <input type="text" class="form-control" formControlName="ReceiverID" [(ngModel)]="ClearH.receiverId">
            </div>
          </div>

          <div class="row mb-1">
            <div class="col-lg-6">
              <label>Receiver ID Qualifier<sup class="super-script">&nbsp;*</sup></label>
            </div>
            <div class="col-lg-6">
              <select class="form-control" formControlName="ReceiverIDQualifierLid"
                [(ngModel)]="ClearH.receiverIDQualifierLid" (ngModelChange)="checkpopup('ReceiverIDQualifierLid')">
                <option [value]=i.Key *ngFor="let i of  RecieveridQualifier">{{i.Value}}</option>
              </select>
            </div>
          </div>

        </form>
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" [disabled]="!clearHouseForm.valid || isSaveorUpdateBoolean"
          (click)="SaveOrUpdateClearnhHouse()"><span *ngIf="ModelType =='new'"> Save &
            Close</span> <span *ngIf="ModelType =='edit'">Update & Close</span> </button>
        <button type="button" class="btn blue-btn btn-sm" (click)="CloseSaveMOdelConfirm()">Close</button>
      </div>
    </div>
  </div>
</div>


<!-- ===============================popup during deleting the payor mapping========================== -->
<span id="openModal3" data-toggle="modal" data-target="#deleteModal"></span>
<div class="modal fade primarymodal" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        Do you want to delete this record?
      </div>
      <div class="modal-footer">
        <button class="btn blue-btn btn-sm" (click)="deleteClearingHousePayorMapping()">Delete</button>
        <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal"
          data-target="#deleteModal">Cancel</button>
      </div>
    </div>
  </div>
</div>

<!-- ==============close without save modal================================= -->
<span id="cancelmodal" data-toggle="modal" data-target="#CloseModal"></span>
<div class="modal fade primarymodal" id="CloseModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog create-update-zip" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title font-header" id="exampleModalLabel">Close</h5>
        <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"></span>
        </button>
      </div>
      <div class="modal-body">
        You want to close without save?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn blue-btn btn-sm" (click)="closeAddUpdateModal()">Yes</button>
        <button type="button" class="btn blue-btn btn-sm" data-dismiss="modal">No</button>
      </div>
    </div>
  </div>
</div>